import { SxProps } from "@mui/material";

export const CommentList: SxProps = {
  maxHeight: "300px",
  overflowY: "auto",
};

export const CommentText: SxProps = {
  fontSize: "0.65rem",
};

export const DisabledCommentListItem: SxProps = {
  backgroundColor: "#EEEEEE",
  borderBottomLeftRadius: "6px",
  borderBottomRightRadius: "6px",
  display: "flex",
  justifyContent: "center",
  fontSize: "1rem",
  fontWeight: "100",
  textDecoration: "underline",
  padding: "10px",
};
